<script>
    import { GAME_COLORS } from '@root/src/constants';
    import { kFormatter } from '@src/utils/ui.js';

    import { backOut } from 'svelte/easing';
    import PatternLine from '../svg-patterns/pattern-line.svelte';

    import plinkoImg from '@src/assets/img/history_line_plinko.webp';
    import ballSpinImg from '@src/assets/img/history_line_ball_spin.webp';
    import cashReelsImg from '@src/assets/img/history_line_cash_reels.webp';
    import fortuneWheelImg from '@src/assets/img/history_line_fortune_wheel.webp';

    export let color = null;
    export let multiplierValue;
    export let win = false;

    function scale(node, options) {
        node.style.transform = `scale(${options.from})`;
        node.style.zIndex = `9999`;

        return {
            ...options,
            css: (t, u) => {
                if (t === 1) {
                    node.style.transform = ``;
                    node.style.zIndex = `auto`;
                }
                return `transform: scale(${(options.from - 1) * (1 - t) + 1});`;
            }
        };
    }

    const ballInfoArr = [
        {
            color: GAME_COLORS.BLACK,
            background: 'bg-sector-black',
            value: 1
        },
        {
            color: GAME_COLORS.LIGHT_BLUE,
            background: 'bg-sector-light-blue',
            value: 2
        },
        {
            color: GAME_COLORS.PURPLE,
            background: 'bg-sector-purple',
            value: 5
        },
        {
            color: GAME_COLORS.ORANGE,
            background: 'bg-sector-orange',
            value: 10
        },
        {
            color: GAME_COLORS.PINK,
            background: 'bg-sector-pink',
            imgSrc: ballSpinImg
        },
        {
            color: GAME_COLORS.BLUE,
            background: 'bg-sector-blue',
            imgSrc: plinkoImg
        },
        {
            color: GAME_COLORS.YELLOW,
            background: 'bg-sector-yellow',
            imgSrc: cashReelsImg
        },
        {
            color: GAME_COLORS.GREEN,
            background: 'bg-sector-green',
            imgSrc: fortuneWheelImg
        }
    ];

    const getBallInfo = color => {
        return ballInfoArr.find(ball => ball.color === color);
    };

    $: ballInfo = color ? getBallInfo(color) : 'bg-cross-n-400/40';
</script>

<div
    in:scale={{ from: 1.75, duration: 1000, delay: 500, easing: backOut }}
    class="relative flex h-5 w-5 origin-top-left rounded-full desktop:h-8 desktop:w-8 {ballInfo?.background}"
    class:!w-full={multiplierValue}
    class:!opacity-50={!win}
>
    {#if !multiplierValue && ballInfo?.value}
        <div
            class="cstm-position-center text-xxs font-bold text-white drop-shadow-[0_1px_1px_rgba(0,0,0,1)] desktop:text-sm"
        >
            {ballInfo?.value}
        </div>
    {:else}
        <div class="cstm-position-center z-10 h-5 w-5" class:!left-3={multiplierValue}>
            <img src={ballInfo?.imgSrc} class="h-full w-full object-contain" alt="bonus game img" />
        </div>
    {/if}

    <div
        class="relative z-[1] h-full w-full origin-top-left overflow-hidden rounded-full border border-white/40 p-1 font-Roboto"
    >
        {#if multiplierValue}
            <PatternLine class="absolute inset-0 h-auto w-full" />
        {/if}

        <div
            class=" flex h-full w-full place-items-center justify-center text-white drop-shadow-[0_1px_1px_rgba(0,0,0,1)]"
        >
            {#if multiplierValue}
                <div class="ml-5 text-xxs font-bold desktop:text-sm">
                    {kFormatter(multiplierValue)}
                </div>
                <div class="text-[8px] font-extralight desktop:text-xxs">×</div>
            {/if}
        </div>
    </div>
</div>
